export const generateTransparentPlaceholder = (width: number, height: number, color: string = 'transparent') => {
  const svgString = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
      <rect width="100%" height="100%" fill="${color}" />
    </svg>
  `;
  const base64Svg = btoa(svgString);

  return `data:image/svg+xml;base64,${base64Svg}`;
};
